var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectedDevicesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 52,
    fill: "#ACACAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    transform: "translate(-826 -167)",
    fill: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -801,
    y: -22,
    width: 1536,
    height: 100,
    rx: 9.94788,
    fill: "#FEFEFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1122 21.6986C37.3266 21.8762 38.3899 22.4212 39.3011 23.3322C40.4333 24.4645 41 25.8311 41 27.4334C41 29.0357 40.4333 30.4022 39.3011 31.5345C38.3948 32.4419 37.3375 32.9857 36.1304 33.1657C36.1546 32.8709 36.1667 32.5712 36.1667 32.2667C36.1667 29.5975 35.223 27.3187 33.3356 25.4311C31.4482 23.5437 29.1692 22.6 26.5 22.6C23.8308 22.6 21.5519 23.5437 19.6644 25.4311C17.777 27.3185 16.8333 29.5975 16.8333 32.2667C16.8333 32.4117 16.8357 32.5555 16.8417 32.6981C15.9005 32.3211 15.0413 31.7447 14.2656 30.969C12.7552 29.4586 12 27.6353 12 25.5C12 21.7506 13.7158 19.3171 17.1488 18.2004C17.6587 16.2212 18.7184 14.5633 20.3278 13.2257C22.1161 11.7419 24.1728 11 26.4999 11C29.1691 11 31.448 11.9437 33.3355 13.8311C35.2229 15.7185 36.1666 17.9975 36.1666 20.6667C36.1666 21.0135 36.1484 21.3567 36.1122 21.6986ZM21.031 26.7976C19.5218 28.308 18.7666 30.1313 18.7666 32.2666C18.7666 34.4019 19.5218 36.2251 21.031 37.7356C22.5414 39.2448 24.3647 40 26.5 40C28.6353 40 30.4585 39.2448 31.969 37.7356C33.4782 36.2252 34.2334 34.4019 34.2334 32.2666C34.2334 30.1313 33.4782 28.3081 31.969 26.7976C30.4586 25.2884 28.6353 24.5332 26.5 24.5332C24.3647 24.5332 22.5415 25.2884 21.031 26.7976ZM24.6258 31.9245L24.2838 31.5825C24.1932 31.4919 24.0881 31.423 23.9697 31.3735C23.8512 31.3239 23.728 31.2998 23.5999 31.2998C23.4718 31.2998 23.3486 31.3239 23.2302 31.3735C23.1118 31.423 23.0066 31.4919 22.916 31.5825C22.7275 31.7722 22.6333 31.9994 22.6333 32.2664C22.6333 32.5334 22.7275 32.7606 22.916 32.9503L24.8493 34.8836C25.039 35.0721 25.2662 35.1664 25.5332 35.1664C25.8003 35.1664 26.0275 35.0721 26.2171 34.8836L30.0838 31.017C30.2723 30.8273 30.3665 30.6001 30.3665 30.3331C30.3665 30.0661 30.2723 29.8389 30.0838 29.6492C29.8941 29.4607 29.6669 29.3664 29.3999 29.3664C29.1329 29.3664 28.9057 29.4607 28.716 29.6492L25.5333 32.8331L24.6258 31.9245Z",
    fill: "#C2D6DF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 17,
    height: 16,
    rx: 8,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.031 27.2644C19.5218 28.7748 18.7666 30.5981 18.7666 32.7334C18.7666 34.8687 19.5218 36.6919 21.031 38.2024C22.5414 39.7116 24.3647 40.4668 26.5 40.4668C28.6353 40.4668 30.4585 39.7116 31.969 38.2024C33.4782 36.692 34.2334 34.8687 34.2334 32.7334C34.2334 30.5981 33.4782 28.7749 31.969 27.2644C30.4586 25.7552 28.6353 25 26.5 25C24.3647 25 22.5415 25.7552 21.031 27.2644ZM24.6257 32.3913L24.2838 32.0493C24.1932 31.9587 24.088 31.8898 23.9696 31.8403C23.8512 31.7907 23.728 31.7665 23.5999 31.7665C23.4718 31.7665 23.3485 31.7907 23.2301 31.8403C23.1117 31.8898 23.0066 31.9587 22.916 32.0493C22.7275 32.239 22.6332 32.4662 22.6332 32.7332C22.6332 33.0002 22.7275 33.2274 22.916 33.4171L24.8493 35.3504C25.039 35.5389 25.2662 35.6332 25.5332 35.6332C25.8002 35.6332 26.0274 35.5389 26.2171 35.3504L30.0837 31.4838C30.2722 31.2941 30.3665 31.0669 30.3665 30.7999C30.3665 30.5329 30.2722 30.3057 30.0837 30.116C29.894 29.9275 29.6669 29.8332 29.3998 29.8332C29.1328 29.8332 28.9056 29.9275 28.7159 30.116L25.5332 33.2999L24.6257 32.3913Z",
    fill: "#9BBCCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_56220",
    x: -803,
    y: -22,
    width: 1540,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.307813 0 0 0 0 0.326577 0 0 0 0 0.375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_56220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_56220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    fill: "white",
    transform: "translate(-826 -167)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedDevicesIcon);
export default __webpack_public_path__ + "static/media/connected-devices-icon.70a6c20af37c550845efb2ad5e5c7375.svg";
export { ForwardRef as ReactComponent };